"use client";

import {Box, HStack, VStack} from "@styled-system/jsx";
import Link from "next/link";

import {CopyRightComponent} from "@/components/common/copyRight.common";
import {JindoWhiteLogo} from "@/components/icon";
import {Button} from "@/components/primitives/button";
import {Heading, Paragraph} from "@/components/primitives/typography";

import {css} from "@styled-system/css";

interface FallbackLayoutProps {
    errorMessage?: string;
    reset?: () => void;
}

export default function FallbackLayout({errorMessage = "Something went wrong!", reset}: FallbackLayoutProps) {
    return (
        <Box
            width="100%"
            height="100vh"
            className={css({
                background: "linear-gradient(168.7deg, #ff9900 -2.34%, #ff9900 31.14%, #ffc930 66.77%, #de2c56 99.17%)",
                color: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                position: "relative"
            })}>
            <VStack gap={8} p={8} maxWidth="500px" align="center" justify="center">
                <Link href="/" prefetch={false}>
                    <JindoWhiteLogo style={{fill: "#ffffff", height: 129, width: 129}} />
                </Link>

                <VStack gap={4} align="center">
                    <Heading
                        css={{
                            fontFamily: "Barlow Condensed",
                            fontSize: "4xl",
                            fontWeight: "bold",
                            textAlign: "center",
                            textShadow: "0px 2px 4px rgba(0, 0, 0, 0.25)"
                        }}>
                        OH NO!
                    </Heading>

                    <Paragraph
                        css={{
                            fontFamily: "Barlow Condensed",
                            fontSize: "xl",
                            fontWeight: "medium",
                            textAlign: "center",
                            maxWidth: "400px"
                        }}>
                        {errorMessage}
                    </Paragraph>
                </VStack>

                <HStack gap={4} pt={4}>
                    <Link href="/" prefetch={false}>
                        <Button
                            size="lg"
                            variant="outlined"
                            css={{
                                borderColor: "white",
                                color: "white",
                                fontFamily: "Barlow Condensed",
                                fontWeight: "bold"
                            }}>
                            GO HOME
                        </Button>
                    </Link>

                    {reset && (
                        <Button
                            size="lg"
                            onClick={reset}
                            css={{
                                bg: "#FF14BD",
                                color: "white",
                                fontFamily: "Barlow Condensed",
                                fontWeight: "bold",
                                _hover: {bg: "#e012a8"}
                            }}>
                            TRY AGAIN
                        </Button>
                    )}
                </HStack>

                <CopyRightComponent cssProp={{opacity: 0.8, pt: 8}} />
            </VStack>
        </Box>
    );
}
